import type { TaskDrawerSliceState } from './taskDrawer.types'

export const createEmptyTaskDrawerState = (): TaskDrawerSliceState => ({
  drawerTaskOverride: null,
  drawerTaskLoading: false,
  syncingTaskIds: {},
  suppressedTaskId: null,
})
